import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useUserRole() {
  const { data: isAdmin = false, isLoading } = useQuery({
    queryKey: ["user-admin-role"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;

      // Use the is_admin RPC function with correct parameter name
      const { data } = await supabase.rpc("is_admin", { _user_id: user.id });

      return !!data;
    },
  });

  return { isAdmin, isLoading };
}
